module.exports = __webpack_public_path__ + "img/blhsg03_center_001.f4c34a46.png";